/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @interface ReplaceBlockParametersPayload
 */

/**
 * Check if a given object implements the ReplaceBlockParametersPayload interface.
 */
export function instanceOfReplaceBlockParametersPayload(value) {
  return true;
}
export function ReplaceBlockParametersPayloadFromJSON(json) {
  return ReplaceBlockParametersPayloadFromJSONTyped(json, false);
}
export function ReplaceBlockParametersPayloadFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    'blockParameters': json['blockParameters'] == null ? undefined : json['blockParameters']
  };
}
export function ReplaceBlockParametersPayloadToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    'blockParameters': value['blockParameters']
  };
}